import React from "react";
import { AiOutlineCloseCircle } from "react-icons/ai";
import AppStoreButton from "@components/buttons/AppStoreButton";
import GooglePlayStoreButton from "@components/buttons/GooglePlayStoreButton";

export default function DownloadTheAppModal({
  downloadAppModalOpen,
  setDownloadAppModalOpen,
}) {
  if (!downloadAppModalOpen) return null;
  return (
    <>
      <div
        className="h-screen w-screen absolute z-20"
        aria-hidden
        style={{ backgroundColor: "rgba(39, 39, 39, 0.550)" }}
        onClick={() => setDownloadAppModalOpen(false)}
      />
      <div className="bg-[#6F4AD4] w-full bottom-0 lg:w-96 h-48 flex flex-col absolute lg:top-1/2 lg:left-1/2 lg:transform lg:-translate-x-1/2 lg:-translate-y-1/2 z-50 justify-between py-6 px-5 mx-auto z-50">
        <AiOutlineCloseCircle
          className="absolute right-0 text-3xl top-6 right-3 text-white cursor-pointer"
          onClick={() => setDownloadAppModalOpen(false)}
        />
        <span className="text-white text-lg font-semibold mb-1">
          Snacktime is better on the app
        </span>
        <span className="text-white text-sm mb-4 w-[90%]">
          Check out the mobile app for the full Snacktime experience 👍
        </span>
        <div className="flex items-center flex-row mt-4">
          <div className="mr-2">
            <AppStoreButton size="small" />
          </div>
          <div>
            <GooglePlayStoreButton size="small" />
          </div>
        </div>
      </div>
    </>
  );
}
